<template>
  <m-dialog
    ref="dlg"
    @save="save"
    title="Ubah Kuota"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <span class="title primary--text">Kuota {{ tenant.organisasi_id ? 'Organisasi' : 'Tenant' }}</span>
            <v-row wrap>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Tanggal Mulai</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  autofocus
                  label="Tanggal Mulai*"
                  v-model="tenant.tgl_mulai"
                  hint="Tanggal Mulai"
                  data-vv-name="tgl_mulai"
                  data-vv-as="Tanggal Mulai"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.tgl_mulai')"
                ></m-datepicker>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Tanggal Selesai</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  autofocus
                  label="Tanggal Selesai*"
                  v-model="tenant.tgl_akhir"
                  hint="Tanggal Selesai"
                  data-vv-name="tgl_akhir"
                  data-vv-as="Tanggal Selesai"
                  v-validate="'required'"
                  :min="tenant.tanggal_mulai"
                  :error-messages="errors.collect('form.tgl_akhir')"
                ></m-datepicker>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                <label class="caption">Total Kuota</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Total Kuota"
                  v-model="tenant.kuota"
                  hint="Total Kuota"
                  data-vv-name="kuota"
                  data-vv-as="Total Kuota"
                  type="number"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.kuota')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      roles: {},
      tenant: {},
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset();
      this.roles = obj || {}
      this.tenant = {}
      if (obj) this.initForm(obj)
      return this.$refs.dlg.open();
    },
    initForm(obj) {
      if (obj && obj.organisasi_id) {
        this.$set(this.tenant, 'organisasi_id', obj.organisasi_id)
        this.$set(this.tenant, 'tgl_mulai', obj.tgl_berlaku_awal)
        this.$set(this.tenant, 'tgl_akhir', obj.tgl_berlaku_akhir)
        this.$set(this.tenant, 'kuota', obj.kuota)
      } else {
        this.$set(this.tenant, 'tgl_mulai', obj.kuota && obj.kuota.start_at)
        this.$set(this.tenant, 'tgl_akhir', obj.kuota && obj.kuota.expired_at)
        this.$set(this.tenant, 'kuota', obj.kuota && obj.kuota.kuota)
      }

      this.$set(this.tenant, 'tenant_id', obj.tenant_id)
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("tenant/updateKuota", this.tenant);
        })
        .then(res => {
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    }
  }
};
</script>
